/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Component, Input, OnInit } from '@angular/core';
import { IFieldDefItem } from '../../../../model/docking';

@Component({
    selector: 'app-maintenance-test-command-input',
    templateUrl: './maintenance-test-command-input.component.html',
    styleUrls: ['./maintenance-test-command-input.component.scss']
})
export class MaintenanceTestCommandInputComponent implements OnInit {
    @Input() fieldDefItem: IFieldDefItem;
    label: string;
    valuePart1: string;
    valuePart2: string;
    valuePart3: string;
    valuePart4: string;

    ngOnInit() {
        if (!this.fieldDefItem) {
            throw new Error('Field def item is undefined');
        }
        if (this.fieldDefItem.type !== 'ipInput') {
            throw new Error('Field def item type is not suported');
        }
        if (this.fieldDefItem.value && !this.isValidIpAddress(this.fieldDefItem.value)) {
            throw new Error('Field def item value is not a valid ip address');
        }
        this.label = this.fieldDefItem.text;
        const valueSplit = this.fieldDefItem.value ? this.fieldDefItem.value.split('.') : null;
        this.valuePart1 = valueSplit ? valueSplit[0] : '';
        this.valuePart2 = valueSplit ? valueSplit[1] : '';
        this.valuePart3 = valueSplit ? valueSplit[2] : '';
        this.valuePart4 = valueSplit ? valueSplit[3] : '';
    }

    isValidIpAddress(value: string): boolean {
        const regExVote103 = RegExp(
            '^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$'
        ); //vote 103, see pull-request for more info
        return regExVote103.test(value);
    }

    getIpAddress(): string {
        return this.valuePart1 !== '' && this.valuePart2 !== '' && this.valuePart3 !== '' && this.valuePart4 !== ''
            ? `${this.valuePart1}.${this.valuePart2}.${this.valuePart3}.${this.valuePart4}`
            : '';
    }

    keypress(event) {
        // Max length is 3
        if (event.target.value.length >= 3) {
            return false;
        }

        // Only Numbers 0-9
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
            return false;
        }

        return true;
    }

    keyup(event) {
        // Clear input field if value not between 0 and 255
        if (event.target.value.trim() !== '') {
            const intValue = parseInt(event.target.value);
            if (intValue < 0 || intValue > 255) {
                event.target.value = '';
            }
        }
    }
}
